import React, { useState, useEffect } from 'react'
import './fullSheetRow.css'
import { FiAlertTriangle, FiChevronDown } from "react-icons/fi";
import { MdClose } from "react-icons/md";

import { changeFullSheetRowWithOpenSelection, changeFullSheetsRowConfig , getFullSheetAvailableThicknesses, selectedThicknessForFullSheetRow, changeFullSheetsInputCheck} from './orderConfig'

const FullSheetRow = React.memo(({ rowID, row, openMaterialSelection, openRemoveConfirmationPopup, fetchRowsConfig }) => {

    const [quantityInput, setQuantityInput] = useState('');
    const [inputAlerts, setInputAlerts] = useState(false);

    // refresh the input values when the component gets item changes (full sheet row config changed for this row)
    useEffect(() => {
        setQuantityInput(row?.quantity || '');;

        let qtyAlert = false;
        if(row?.quantity != null && row?.quantity <= 0){
            qtyAlert = true;
        }

        setInputAlerts(qtyAlert);

    }, [row]);

    const handleQtyChange = (event) =>{
        const value = event.target.value;
        if (row?.thickness != null) {
            const integerOnly = value.replace(/[^0-9]/g, '');

            changeFullSheetsRowConfig(rowID, integerOnly);
            setQuantityInput(integerOnly);
            setInputAlerts(integerOnly > 0 ? false : true);
            if(integerOnly <= 0){
                changeFullSheetsInputCheck(rowID, false);
            }else{
                changeFullSheetsInputCheck(rowID, true);
            }
            fetchRowsConfig();
        }
    }

    const handleOpenMaterialSelect = () => {
        console.log('Opening material select for row:' + rowID);
        openMaterialSelection(rowID);
    };

    //  Thickness dropdown handlers
    const [thicknessDropdownOpen, setThicknessDropdownOpen] = useState(false);
    const [thicknessDropdownOptions, setThicknessDropdownOptions] = useState([]);
    const toggleThicknessDropdown = () =>{
        if(row?.productCode !== null){
            setThicknessDropdownOpen(!thicknessDropdownOpen);
            if(!thicknessDropdownOpen == true){
                loadThicknessDropdownOptions();
            }
        }
    }
    const closeThicknessDropdown = () =>{
        setThicknessDropdownOpen(false);
    }
    const loadThicknessDropdownOptions = () =>{
        changeFullSheetRowWithOpenSelection(rowID);
        const thicknesses = getFullSheetAvailableThicknesses();
        setThicknessDropdownOptions(thicknesses);
    }
    const handleThicknessChange = (thickness) => {
        selectedThicknessForFullSheetRow(thickness);
        closeThicknessDropdown();
        fetchRowsConfig();
    }

    return (
        <div className='fullSheetsListRow'>
            <div className='fullSheetsListRowInputs'>
                <div className='grid_item'><p>{rowID + 1}</p></div>
                <div className='grid_item'>
                    <div className='rowBtn' style={{cursor: 'pointer'}} onClick={() => handleOpenMaterialSelect()}>
                        <p>{row?.productCode !== null ? row?.productCode : 'Select decor'}</p>
                    </div>
                </div>
                <div className='grid_item'>
                <div className='thicknessDropdown'>
                    <div className='thicknessDropdownTop' style={{cursor: 'pointer'}} onClick={() => toggleThicknessDropdown()}>
                            <div className='thicknessDropdownTopValue'>
                                <p>{row?.thickness}</p>
                            </div>
                            <FiChevronDown />
                        </div>
                        <div className='thicknessDropdownMenu' style={{display: thicknessDropdownOpen === true ? 'flex' : 'none'}}>
                            {thicknessDropdownOptions.map((thickness, index) => (
                                <div key={index} className='thicknessDropdownMenuItem' onClick={() => handleThicknessChange(thickness)}><p>{thickness}</p></div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className='grid_item'>
                    <p>{row?.materialLength != null ? row?.materialLength : '-'}</p>
                </div>
                <div className='grid_item'>
                    <p>{row?.width != null ? row?.width : '-'}</p>
                </div>
                <div className='grid_item'>
                    <input className='inputField' value={quantityInput} onChange={handleQtyChange} disabled={row?.thickness != null ? false : true} style={{borderColor: inputAlerts === true ? '#fb0429' : '#ccc'}}></input>
                    <div className='rowInputAlert' style={{display: inputAlerts=== true ? 'flex' : 'none'}}>
                        <FiAlertTriangle className='rowInputAlertIcon'/>
                        <p className='rowInputAlertText'>Minimum quantity is 1</p>
                    </div>
                </div>
                <div className='grid_item'>
                    <p>{row?.brand != null ? row?.brand : '-'}</p>
                </div>
                <div className='grid_item'>
                    <div className='fullSheetActions'>
                        <MdClose style={{color: '#fb0429', scale: '1.7', cursor: 'pointer'}}
                            onClick={() => openRemoveConfirmationPopup(rowID)}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
});

export default FullSheetRow